var _class, _descriptor, _descriptor2, _descriptor3;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import Service, { inject as service } from '@ember/service';
import { setItemSubunitsServiceMerchantSubunits } from '@square/dashboard-utilities/utils/item-subunits';
import { assert } from '@ember/debug';
import { tracked } from '@glimmer/tracking';
/**
 * Used by items-v3-base and other items library routes to get a list of the merchant's item subunits.
 */
let ItemSubunits = (_class = class ItemSubunits extends Service {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "merchantSubunitStore", _descriptor, this);
    _initializerDefineProperty(this, "store", _descriptor2, this);
    _initializerDefineProperty(this, "selectedSubunit", _descriptor3, this);
  }
  getSelectedSubunit() {
    return this.selectedSubunit;
  }
  setSelectedSubunit(subunit) {
    this.selectedSubunit = subunit;
  }
  async fetchMerchantSubunits() {
    assert('ItemSubunits requires the MerchantSubunitStore service', typeof this.merchantSubunitStore !== 'undefined');
    const [allForMerchant, authorized] = await Promise.all([this.store.findAll('merchant-subunit-ed'), this.merchantSubunitStore.findAuthorized()]);
    setItemSubunitsServiceMerchantSubunits(allForMerchant.toArray(), true);
    setItemSubunitsServiceMerchantSubunits(authorized);
    return authorized;
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "merchantSubunitStore", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "store", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "selectedSubunit", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return null;
  }
}), _class);
export { ItemSubunits as default };